import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, InputAdornment, List, TextField, Typography } from '@mui/material';

// project imports
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import { useState } from 'react';
import SearchIcon from "@mui/icons-material/Search";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();
  const [searchText, setSearchText] = useState("");

  const filterMenu = (menu, search) => {
  if (!search) return menu;

  return menu
    ?.map((item) => {
      if (item.children) {
        const filteredChildren = filterMenu(item.children, search);

        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
      }

      if (
        item.title &&
        item.title.toLowerCase().includes(search.toLowerCase())
      ) {
        return item;
      }

      return null;
    })
    .filter(Boolean);
};

const filteredChildren = filterMenu(item.children, searchText);

  // menu list collapse & items
  const items = filteredChildren?.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  

  return (
    <>
    <Box sx={{  pt: 2 }}>
      

  <TextField
    fullWidth
    size="small"
    placeholder="Search Menu..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius:"10px",
       
        "&:hover fieldset": {
          borderColor: "#ABF7B1"

        },
        "&.Mui-focused fieldset": {
          borderColor: "#ABF7B1",
          borderWidth: "1px"
        }
      }
    }}
  />
</Box>



      <List
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;